import React from 'react';

function PaymentSuccessful() {
  return (
    <div className="w-full flex flex-col justify-center items-center bg-system-100 p-6 rounded-lg gap-5">
      <div className="w-full font-title lg:text-lg text-2xl text-black font-semibold">
        Ha finalizado su compra con éxito
      </div>
      <h1 className="text-neutral-cold-400">
        Gracias por su compra, espere un momento mientras se crea su orden
      </h1>
    </div>
  );
}

export default PaymentSuccessful;
